// import store from '@/store'
// import http from '@/http'

// Panel
import Recibos from './Recibos' // menus

const BASE_PATH = '/recibos'

const routes = [
  {
    path: BASE_PATH,
    name: 'listarRecibos',
    meta: {
      requiresAuth: true,
      requiredRoles: ['lyris', 'user', 'empleado', 'empleador']
    },
    component: Recibos,
    props: true
  }
  /*
  {
    path: BASE_PATH + '/pendientes',
    name: 'listarRecibosPend',
    meta: {
      requiresAuth: true,
      requiredRoles: ['lyris', 'user', 'empleado', 'empleador']
    },
    component: RecibosPendientes,
    props: true
  },
  {
    path: BASE_PATH + '/historial',
    name: 'listarRecibosHist',
    meta: {
      requiresAuth: true,
      requiredRoles: ['lyris', 'user', 'empleado', 'empleador']
    },
    component: RecibosHist,
    props: true
  }
  */
]
export default routes
